/* eslint-disable no-unused-expressions */
// 车型库首页
import React, { useEffect, useState } from 'react'
import Head from 'next/head'
import { get } from 'lodash'
import { SingletonRouter, withRouter } from 'next/router'

import getUrl from 'lib/url'
import TongLan from '../ad/tonglan'
import Brand from './brand'
import ConditionsList from './conditions-list'
import { ContextProvider } from './reducer'
import { IConditionsProps, IInfoProps, ISortProps } from './interface'
import fetch from 'lib/decorated-fetch'
interface IAutoProps {
  // 过滤条件
  conditions: IConditionsProps[]
  // 排序条件
  sort: ISortProps[]
  // 品牌
  brands: IInfoProps[][]
  // 品牌字母
  letters: string[]
  // url中的query，用来初始化搜索结果
  query: any
  router: SingletonRouter
  options: any
  initProps: any
  asPath?: string
}

function Auto(props: IAutoProps) {
  const { query, options, conditions, sort, letters, brands, initProps } = props
  const [init, setInit] = useState<any>(() => {
    return {
      ...initProps,
      ...options,
    }
  })
  const foldParam = !!query.searchParams
    ?.split('-')
    ?.slice(5)
    ?.filter((item: any) => item !== 'x').length

  return (
    <>
      <TongLan />
      <div>
        <Head>
          <title key="title">
            车型库 - {new Date().getFullYear()}最新汽车价格 - 汽车报价大全 -
            懂车帝
          </title>
          <meta
            key="keywords"
            name="keywords"
            content="懂车帝官网,汽车,汽车网站,汽车报价,汽车报价大全,汽车大全,汽车价格查询,汽车图片,车型库,汽车之家报价,汽车标志"
          />
          <meta
            key="description"
            name="description"
            content="懂车帝提供最全面的汽车车型大全，包括2019最新汽车报价查询、品牌最全车型最全的全国最低价格及本地报价、图片、评测、口碑、经销商、油耗、资讯等信息，看车选车买车就上懂车帝。"
          />
          <link
            rel="canonical"
            href={`https://www.dongchedi.com/${props?.asPath?.split('?')?.[0]}`}
          />
        </Head>
        <ContextProvider initProps={init}>
          <Brand letters={letters} brands={brands} conditions={conditions} />
          <ConditionsList
            conditions={conditions}
            sort={sort}
            foldProps={foldParam}
          />
        </ContextProvider>
        <style jsx>
          {`
            div {
              width: 1190px;
              margin: 24px auto 0 auto;
            }
          `}
        </style>
      </div>
    </>
  )
}

// 重新处理数据
function reHandleData(data: any, query: any) {
  // 更多条件
  const conditions = get(data, '[2].info.filters[3].data.options', [])
  conditions?.forEach((item: IConditionsProps) => {
    item.data.unshift({
      text: '不限',
      key: '',
      param: 'x',
    })
  })

  // 价格
  const price = get(data, '[2].info.filters[1].data.options', [])
  const newPrice = price.map((item: ISortProps) => {
    return {
      param: item.text === '价格不限' ? 'x' : item.param,
      text: item.text === '价格不限' ? '不限' : item.text,
      key: 'price',
    }
  })
  // 价格允许自定义
  newPrice.push({
    key: 'price',
    text: '输入框',
  })
  conditions.unshift({ title: '价格', data: newPrice })

  // 按价格排序等过滤条件
  const sort = get(data, '[2].info.filters[0].data.options', []).map(
    (item: ISortProps) => {
      return {
        key: 'sort',
        text: item.text,
        param: item.param,
      }
    }
  )

  // 处理品牌
  let list: IInfoProps[] = []
  const brands: IInfoProps[][] = []
  const letters: string[] = []
  data &&
    data.slice(3)?.forEach((item: IInfoProps) => {
      if (item.type === '1000') {
        letters.push(item.info.pinyin)
        brands.push(list)
        list = []
      }
      if (item.type === '1000' || item.type === '1001') {
        list.push(item)
      }
    })
  brands.push(list)
  brands.shift()
  const options: any = {}

  if (query.searchParams) {
    const paramsList = query.searchParams.split('-')

    conditions?.forEach((item: any, index: number) => {
      const param = paramsList?.[index] === 'x' ? 'x' : paramsList?.[index]
      if (index !== 10 && index !== 9) {
        if (index === 0) {
          const newItem: ISortProps | undefined = item.data.find(
            (option: any) =>
              option?.param?.toString() === param.toString().replace('!', '-')
          )
          if (newItem?.text === '不限') {
            return
          }
          try {
            const [low, high] = param.split(',')
            if (high === '!1') {
              options.price = [
                newItem || {
                  param: param.toString().replace('!', '-'),
                  text: `${low}万以上`,
                  key: 'price',
                },
              ]
            } else {
              options.price = [
                newItem || {
                  param: param.toString().replace('!', '-'),
                  text: `${param.split(',').join('-')}万`,
                  key: 'price',
                },
              ]
            }
          } catch (e) {
            console.error(e)
          }
        } else {
          const newItem: ISortProps | undefined = item.data.find(
            (option: any) =>
              option?.param?.toString() === param?.toString()?.replace('!', '-')
          )
          if (newItem?.key !== undefined && newItem?.key !== '') {
            options[newItem.key] = [newItem]
          }
        }
      } else {
        const list = paramsList?.[index]?.split('_').map((item: string) => {
          return parseInt(item, 10) || 0
        })
        list?.forEach((index: number) => {
          const newItem = item.data[index]
          if (newItem?.key !== '') {
            options[newItem.key] = [newItem]
          }
        })
      }
    })
  }
  return {
    options,
    conditions,
    sort,
    letters,
    brands,
  }
}

function handlePath(asPath: string) {
  const search = typeof asPath !== 'undefined' && asPath && asPath.split('?')[1]
  const queries = {} as any
  let initProps = {} as any
  if (search) {
    search.split('&').forEach(function (c: string) {
      if (c === '') {
        return
      }
      const splitArr = c.split('=')
      const key = splitArr[0]
      queries[key] = splitArr.slice(1)
    })
    const keys = queries['key'] || ([] as string[])
    const param = queries['param'] || ([] as string[])
    const text = queries['text'] || ([] as string[])
    if (keys) {
      initProps = keys.reduce((acc: any, curr: string, index: number) => {
        if (!curr) {
          return acc
        }
        if (!acc[curr]) {
          acc[curr] = []
        }
        acc[curr].push({
          param: Number(param[index]) || param[index],
          text: decodeURIComponent(text[index]),
        })
        return acc
      }, {})
    }
  }
  return initProps
}

Auto.getInitialProps = async ({ query, asPath, req }: any) => {
  const json =
    (await fetch(
      getUrl('/motor/brand/m/v1/brand/?device_id=0', 'motor.brand.api'),
      {
        req,
      }
    ).catch((err) => {
      // no-op
    })) || {}

  const data = reHandleData(json.data, query) || {}
  const initProps = handlePath(asPath)
  return {
    ...data,
    query,
    initProps,
    asPath,
  }
}

export default withRouter<IAutoProps>(Auto)
